import { IMAGES } from "@/lib/constants";
import { Box } from "@mui/material";
import Image from "next/image";
import React from "react";
const COLORS = {
  primary: "#004F45",
  success: "#00D639",
  cardBackground: "#E6F1F1",
  pageBackground: "#F5FAFA",
  iconBackground: "#DDEBEB",
  bodyText: "#666A6B",
  mutedText: "#979797",
  timeline: "#87AAA7",
};

const StepIcon = ({ Icon }) => {
  return (
    <Box
      sx={{
        width: { xs: 40, md: 52 },
        height: { xs: 40, md: 52 },
        borderRadius: "50%",
        border: "1px solid #E5E7EB",
        backgroundColor: "#0041350D",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Image
        fill
        style={{
          objectFit: "contain",
          padding: "6px",
        }}
        src={IMAGES[Icon]}
        alt="Step icon"
      />
    </Box>
  );
};

export default StepIcon;
